module.exports = __webpack_public_path__ + "img/img14.fa0cddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img14.png
// module id = 190
// module chunks = 0